<template>
    <div class="exchange-settlement-detail-view">
        <div class="payment-number">
            <div class="text">NO：<span>{{ dataForm.paymentAppVo.clientNumber }}</span></div>
        </div>

        <div class="collectionInfo">
            <h3>收款信息</h3>
            <div class="collectionName">
                <div class="supplier">收款方</div>
                <p>{{ dataForm.paymentAppVo.revIdDesc }}</p>
            </div>

            <el-row>
                <el-col :span="16" class="paymentMoney">
                    <h5>收款金额：</h5>

                    <div class="other number">{{settlementAmount }}<span>({{ dataForm.paymentAppVo.settleCurrencyIdDesc || '' }})</span></div>
                    <div class="symbol1">
                        <el-icon>
                        <CloseBold />
                        </el-icon>
                    </div>
                    <div class="rate">汇率：<span class="number">{{ dataForm.paymentAppVo.settleRate }}</span></div>
                    <div class="symbol2">=</div>
                    <div class="renminbi number">
                        {{ dataForm.paymentAppVo.applyCurrencyIdDesc || '' }}：<span>{{ dataForm.paymentAppVo.applyAmount || '' }}</span><span>({{ dataForm.paymentAppVo.applyCurrencyNumber || '' }})</span>
                        <div class="prompt">
                            <div v-if="dataForm.paymentAppVo.isAdvance" class="advances">垫资</div>
                            <div v-if="dataForm.paymentAppVo.disableUnitId" class="advances">委托收款</div>
                        </div>
                    </div>
                </el-col>

                <el-col :span="8" class="premium">
                    <!-- <template v-if="dataForm.paymentAppVo.paymentType == '01' && ['01', '02'].includes(dataForm.paymentAppVo.bizType)">
                        手续费：<div>{{dataForm.paymentAppVo.chargesBearerCny?dataForm.paymentAppVo.chargesBearerCny : 0}}<span>(CNY)</span></div>
                    </template> -->
                </el-col>
                    
                <el-col :span="8" style="padding-top:17px">
                    收款银行：<span>{{ dataForm.paymentAppVo.revBankIdDesc || '' }}</span>
                </el-col>
                <el-col :span="8">SWIFT/联行号：<span class="orange30 number">{{ dataForm.paymentAppVo.swiftCode || dataForm.paymentAppVo.revBankCode || '' }}</span></el-col>
                <el-col :span="8">银行账号：<span class="orange30 number">{{ $filters.formatBankAccount(dataForm.paymentAppVo.revBankAccount || '') }}</span></el-col>
                <el-col :span="8">
                    手续承担方式：
                    {{ dataForm.paymentAppVo.feeBearerDesc || '' }}
                </el-col>
                <el-col :span="8">款项类型：<span>{{ dataForm.paymentAppVo.paymentTypeDesc || '' }}</span></el-col>
                <el-col :span="8">银行备注：<span>{{ dataForm.paymentAppVo.remark || '' }}</span></el-col>
            </el-row>

            <div class="ordersInfo">
                <h3>订单信息</h3>
                <ab-table
                    stripe
                    class="materialTable"
                    ref="table1"
                    selectionWidth="45"
                    indexWidth="50"
                    widths="140"
                    :column-list="columns"
                    :table-list="dataForm.paymentAppPayVoList"
                ></ab-table>
            </div>
        </div>

        <el-alert
            v-if="dataForm.paymentAppVo.remarkPreClient"
            :title="'备注：' + dataForm.paymentAppVo.remarkPreClient"
            type="warning"
            :closable="false"
        ></el-alert>
    </div>
</template>

<script>
export default {
    props: {
        routeQuery: {
            type: Object,
            default () {
                return {}
            }
        },

        options: {
            type: Object,
            default () {
                return {}
            }
        },

        dataForm: {
            type: Object,
            default () {
                return {}
            }
        },

        linkParames: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    props: 'billDate',
                    labels: '订单日期',
                    widths: 120
                },
                {
                    props: 'clientBillNumber',
                    labels: '订单编号',
                    widths: 180
                },
                {
                    props: 'customerName',
                    labels: '境外客户',
                    widths: 200
                },
                {
                    props: 'expenseItemIdDesc',
                    labels: '计费项目',
                    widths: 100
                },
                {
                    props: 'applyAmountFormat',
                    labels: '本次申请金额',
                    widths: 120,
                    type: 'money',
                    align: 'right'
                },
                {
                    props: 'prePaymentAmount',
                    labels: '可付金额',
                    widths: 120,
                    type: 'money',
                    align: 'right'
                },
                {
                    props: 'entrustAmount',
                    labels: '订单金额',
                    widths: 120,
                    type: 'money',
                    align: 'right'
                },
                {
                    props: 'currencyIdDesc',
                    labels: '币别',
                    widths: 100,
                    align: 'center'
                }
            ]
        }
    },
    computed: {
        settlementAmount() {
            let amount = 0
            if (this.dataForm.paymentAppVo.applyAmount) {
                if (['03', '04', '06'].includes(this.dataForm.paymentAppVo.bizType)) {
                amount = this.dataForm.paymentAppVo.applyAmount / this.dataForm.paymentAppVo.settleRate
                } else {
                amount = this.dataForm.paymentAppVo.applyAmount * this.dataForm.paymentAppVo.settleRate
                }
            }
            return amount ? Number(amount).toFixed(2) : 0
        }
    }
}
</script>

<style lang="scss">
    .exchange-settlement-detail-view {
        text-align: left;
        border-top: 1px solid #f0f2f5;
        color: #000000;
        font-weight: 400;
        h3 {
            margin-top: 34px;
            font-size: 18px;
        }
        .premium{
            margin-top: 32px;
            div{
                font-family: DIN_Condensed_Bold;
                display: inline-block;
                color: #f87243;
                font-size: 30px;
                font-weight: 500;
                span{
                    color: #f87243;
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
        .collectionInfo {
            padding-bottom: 7px;
            font-size: 14px;
            border-bottom: 1px solid #f0f2f5;
            .collectionName {
            width: 100%;
            display: flex;
            padding: 36px 0 20px;
            line-height: 24px;
            border-bottom: 1px solid #f0f2f5;
            .supplier {
                padding: 5px 15px;
                margin-right: 20px;
                height: 24px;
                line-height: 14px;
                border-radius: 4px;
                background-color: #f0f2f5;
                font-size: 14px;
            }
            p {
                font-size: 22px;
                font-weight: bold;
            }
            }
            .el-col.paymentMoney {
            font-size: 14px;
            margin: 32px 0 10px;
            div,
            h5 {
                display: inline-block;
            }
            .other {
                font-size: 30px;
                font-weight: 500;
                span {
                font-size: 14px;
                font-weight: 500;
                }
            }
            .symbol1 {
                margin: 0 20px;
                color: #7f7f7f;
            }
            .rate {
                span {
                color: #f87243;
                font-size: 30px;
                font-weight: 500;
                }
            }
            .symbol2 {
                margin: 0 20px;
                color: #7f7f7f;
                font-size: 20px;
                font-weight: 500;
            }
            .renminbi {
                position: relative;
                & span:first-child {
                color: #f87243;
                font-size: 30px;
                font-weight: 500;
                }
                & span:nth-child(2) {
                color: #f87243;
                font-size: 14px;
                font-weight: 500;
                }
                .prompt{
                    position: absolute;
                    top: 0px;
                    right: -127px;
                    display: flex;
                    text-align: left;
                    width: 125px;
                }
                .advances {
                color: #0a7cff;
                padding: 0 8px;
                height: 24px;
                background-color: #f0f2f5;
                line-height: 24px;
                text-align: center;
                border-radius: 4px;
                margin-right: 4px;
                }
            }
            }
            .el-col {
            margin-bottom: 30px;
            }
            .mar-bom30 {
            margin-bottom: 30px;
            }
            //字体颜色
            .black26 {
            color: #000000;
            font-size: 26px;
            font-weight: 500;
            }
            .orange30 {
            font-size: 30px;
            font-weight: 500;
            color: #f87243;
            }
            .orange18 {
            font-size: 18px;
            color: #f87243;
            }
        }
        .ordersInfo {
            margin-bottom: 36px;
            .materialTable {
            margin-top: 37px;
            }
        }

        .el-alert {
            margin: 40px 0 36px;
            line-height: 20px;
        }
        .footer {
            margin: 20px;
            text-align: center;
        }
        // 标签
        .payment-number {
            position: absolute;
            width: 200px;
            top: 0px;
            right: 0px;
            border-radius: 0 0 8px 8px;
            background-color: #f2f7ff;
            font-size: 14px;
            text-align: center;
            .text {
            padding: 10px 0;
            }
            .time {
            padding: 10px 0;
            }
        }
    }
</style>